import { type Meta } from '../types/docs';
import {
  AUTOMATION_CREATE_STARTED_LOCATIONS,
  AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
  AUTOMATIONS_ANALYTICS_ENTRY_SOURCES,
} from './automationsAnalytics';

const META: Meta = {
  description: 'The user starts creating a new automation',
  name: 'automation_create_started',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Where the create flow was started from',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...AUTOMATION_CREATE_STARTED_LOCATIONS],
    },
    {
      description: 'How the user entered the create flow (skill_automate when started from a skill)',
      name: 'entry_source',
      required: false,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_ENTRY_SOURCES],
    },
    {
      description: 'The skill id when entry_source is skill_automate',
      name: 'skill_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
